export const getPercentage = (partialValue, totalValue) => {
  const value = (100 * (partialValue + 1)) / totalValue;
  return value / 100;
};
